import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { ActionButtonsStyle, CustomersAccountsListSettingsFormStyle, DataFillFormStyle, RecordsPerPageFormStyle } from './css/CustomersAccountsListSettingsFormStyle'

function DateFilterForm(props) {
  const app = props.app
  const [date, setDate] = props.date
  const dateCreatedFetchAllBtnRef = useRef(null)
  const defaultDate = {
    from: (new Date(app.getClientDateTime()).getFullYear() + '-01'),
    to: (new Date(app.getClientDateTime()).getFullYear() + '-12')
  }

  useEffect(() => {
    dateCreatedFetchAllBtnRef.current.focus()
  }, [])

  const onChangeDateCreatedCheck = (e) => {
    const fetch_all = date.date_created_fetch_all
    setDate({
      ...date,
      date_created_from: fetch_all ? defaultDate.from : '',
      date_created_to: fetch_all ? defaultDate.to : '',
      date_created_fetch_all: (!fetch_all)
    })
  }

  const onChangeDateModifiedCheck = (e) => {
    const fetch_all = date.date_modified_fetch_all
    setDate({
      ...date,
      date_modified_from: fetch_all ? defaultDate.from : '',
      date_modified_to: fetch_all ? defaultDate.to : '',
      date_modified_fetch_all: (!fetch_all)
    })
  }

  return (
    <React.Fragment>
      <div id='dates' className='form-container'>
        <h4 className='header-caption'>Filter date range</h4>
        <div style={{fontSize: '0.7em', margin: '10px 0', paddingLeft: '10px'}}>
          <p> Will only fetch the data within these ranges of date.</p>
        </div>
        <div id='date-filter-form-container'>

          {/********** DATE CREATED ***********/}
          <div className='date-filter-form'>
            <label>Date Created</label>
            <hr/>
            <div className='date-field-form-container'>
              <div
                id='date-created-fetch-all-container'
                className="checkbox-fetch-all-container">
                <input
                  ref={dateCreatedFetchAllBtnRef}
                  className='top-anchor'
                  id="date-created-checkbox-fetch-all"
                  checked={date.date_created_fetch_all}
                  onChange={onChangeDateCreatedCheck}
                  type="checkbox"
                />
                {' '}
                <button
                  type="button"
                  className='fetch-all-btn'
                  onClick={onChangeDateCreatedCheck}
                  id="date-created-fetch-all-btn">
                  Fetch all
                </button>
              </div>
              <div className='date-from'>
                <label>From</label>
                <input
                  disabled={date.date_created_fetch_all}
                  value={date.date_created_from || ''}
                  onChange={(e) => {
                    setDate({ ...date, date_created_from: e.target.value })
                  }}
                  type='month'
                />
              </div>
              <div className='date-to'>
                <label>To</label>
                <input
                  disabled={date.date_created_fetch_all}
                  value={date.date_created_to || ''}
                  onChange={(e) => {
                    setDate({ ...date, date_created_to: e.target.value })
                  }}
                  type='month'
                />
              </div>
            </div>
          </div>

          <br/>

          {/********** DATE MODIFIED ***********/}
          <div className='date-filter-form'>
            <label>Date Modified</label>
            <hr/>
            <div className='date-field-form-container'>
              <div
                id='date-modified-fetch-all-container'
                className="checkbox-fetch-all-container">
                <input
                  id="date-modified-checkbox-fetch-all"
                  checked={date.date_modified_fetch_all}
                  onChange={onChangeDateModifiedCheck}
                  type="checkbox"
                />
                {' '}
                <button
                  type="button"
                  className='fetch-all-btn'
                  onClick={onChangeDateModifiedCheck}
                  id="date-modified-fetch-all-btn">
                  Fetch all
                </button>
              </div>
              <div className='date-from'>
                <label>From</label>
                <input
                  disabled={date.date_modified_fetch_all}
                  value={date.date_modified_from || ''}
                  onChange={(e) => {
                    setDate({ ...date, date_modified_from: e.target.value })
                  }}
                  type='month'
                />
              </div>
              <div className='date-to'>
                <label>To</label>
                <input
                  disabled={date.date_modified_fetch_all}
                  value={date.date_modified_to || ''}
                  onChange={(e) => {
                    setDate({ ...date, date_modified_to: e.target.value })
                  }}
                  type='month'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <DataFillFormStyle />
    </React.Fragment>
  )
}

function RecordsPerPageForm(props) {
  const [footer, setFooter] = props.footer

  const onChange = (e) => {
    if (e.target.value) setFooter({ record_per_page: parseInt(e.target.value) })
    else setFooter({ record_per_page: e.target.value })
  }

  return (
    <React.Fragment>
      <div id='rpp' className='form-container'>
        <h4 className='header-caption'>Records/Page</h4>
        <div id='rpp-form'>
          <label>Records/Page</label>
          <input
            type='number'
            value={footer.record_per_page}
            onChange={onChange}
          />
        </div>
      </div>
      <RecordsPerPageFormStyle />
    </React.Fragment>
  )
}

function ActionButtons(props) {
  const updateCustomersAccountsSettings = props.updateCustomersAccountsSettings

  return (
    <React.Fragment>
      <div id='buttons' className='form-container'>
        <div id='action-button-container'>
          <button
            onClick={(e) => {
                updateCustomersAccountsSettings()
                ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
              }}
            className='pospro-action-btn'>
            Apply
          </button>
          <button
            onClick={(e) => {
                ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
              }}
            className='pospro-action-btn bottom-anchor'>
            Close
          </button>
        </div>
      </div>
      <ActionButtonsStyle />
    </React.Fragment>
  )
}

function useCustomersAccountsListSettingsForm(props) {
  const app = props.app
  const { customersAccountsListController } = props
  const [customersAccountsSettings, setCustomersAccountsSettings]  = customersAccountsListController.customersAccountsSettings
  const [date, setDate] = useState({ ...customersAccountsSettings.date })
  const [footer, setFooter] = useState({ ...customersAccountsSettings.footer })

  const obj = {
    customersAccountsSettings: [customersAccountsSettings, setCustomersAccountsSettings],
    date: [date, setDate],
    footer: [footer, setFooter],
    updateCustomersAccountsSettings: async () => {
      await customersAccountsListController.saveCustomersAccountsSettings(app, { date, footer } )
      setCustomersAccountsSettings({date, footer})
    }
  }

  return (obj)
}

function CustomersAccountsListSettingsForm(props) {
  const customersAccountsListSettingsForm = useCustomersAccountsListSettingsForm(props)
  return (
    <React.Fragment>
      <div id='main-container'>
        <div className='content-wrapper'>
          <DateFilterForm app={props.app} date={customersAccountsListSettingsForm.date} />
          <RecordsPerPageForm footer={customersAccountsListSettingsForm.footer} />
        </div>
        <ActionButtons updateCustomersAccountsSettings={customersAccountsListSettingsForm.updateCustomersAccountsSettings} />
      </div>
      <CustomersAccountsListSettingsFormStyle />
    </React.Fragment>
  )
}

export default React.memo(CustomersAccountsListSettingsForm)